import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const ACCESS_KEY = "kaffa_access_token";
const REFRESH_KEY = "kaffa_refresh_token";

export const tokenStore = {
  get: () => {
    try { return localStorage.getItem(ACCESS_KEY); } catch { return null; }
  },
  getRefresh: () => {
    try { return localStorage.getItem(REFRESH_KEY); } catch { return null; }
  },
  set: (access, refresh) => {
    try {
      if (access) localStorage.setItem(ACCESS_KEY, access);
      else localStorage.removeItem(ACCESS_KEY);
      if (refresh !== undefined) {
        if (refresh) localStorage.setItem(REFRESH_KEY, refresh);
        else localStorage.removeItem(REFRESH_KEY);
      }
    } catch { /* storage disabled */ }
  },
  clear: () => {
    try {
      localStorage.removeItem(ACCESS_KEY);
      localStorage.removeItem(REFRESH_KEY);
    } catch { /* */ }
  },
};

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Attach Bearer token (fallback when third-party cookies are blocked by the browser)
api.interceptors.request.use((config) => {
  const t = tokenStore.get();
  if (t) {
    config.headers = config.headers || {};
    if (!config.headers.Authorization) {
      config.headers.Authorization = `Bearer ${t}`;
    }
  }
  return config;
});

// Auto-refresh on 401 (once per request) — uses refresh_token from cookie OR localStorage
let refreshing = null;
api.interceptors.response.use(
  (r) => r,
  async (error) => {
    const original = error.config || {};
    const status = error.response?.status;
    const url = original.url || "";
    if (
      status === 401 &&
      !original._retried &&
      !url.includes("/auth/login") &&
      !url.includes("/auth/refresh") &&
      !url.includes("/auth/register")
    ) {
      original._retried = true;
      try {
        if (!refreshing) {
          const refresh = tokenStore.getRefresh();
          refreshing = api
            .post("/auth/refresh", refresh ? { refresh_token: refresh } : {})
            .then((res) => {
              tokenStore.set(res.data.access_token, res.data.refresh_token);
              return res;
            })
            .finally(() => { refreshing = null; });
        }
        await refreshing;
        return api.request(original);
      } catch (e) {
        tokenStore.clear();
        throw e;
      }
    }
    throw error;
  }
);

// Helpers to normalise FastAPI errors
export function formatApiErrorDetail(detail) {
  if (detail == null) return "Algo deu errado. Tente novamente.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) {
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" · ");
  }
  // Structured error: { code, field, message, rejection_reason? }
  if (detail && typeof detail.message === "string") {
    if (detail.code === "registration_rejected" && detail.rejection_reason) {
      return `${detail.message}\n\n${detail.rejection_reason}`;
    }
    return detail.message;
  }
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default api;
